// extracted by mini-css-extract-plugin
export default {"select":"static-React-HVJS-HVUI-Select-___index-module__select"};